/**
 * Grouping for the DB grid's right-click menu (owner, 30.09.2026: Copy ▸ and
 * Filter ▸ as submenus instead of a long flat list).
 *
 * `submenu(label, children)` returns a parent item for DbGridContextMenu, or
 * null when there is nothing to put in it. Leading/trailing/doubled
 * separators are dropped. When every child is disabled the parent is disabled
 * too, with the first child's reason as its tooltip — a flyout of greyed-out
 * items says less than one greyed-out row that explains why.
 */
export function trimSeparators(items) {
  const out = [];
  for (const it of items || []) {
    if (!it) continue;
    if (it.separator && (out.length === 0 || out[out.length - 1].separator)) continue;
    out.push(it);
  }
  while (out.length && out[out.length - 1].separator) out.pop();
  return out;
}

export function submenu(label, children) {
  const kids = trimSeparators(children);
  const actions = kids.filter((k) => !k.separator);
  if (actions.length === 0) return null;
  const allDisabled = actions.every((k) => k.disabled);
  return {
    label,
    submenu: kids,
    disabled: allDisabled || undefined,
    title: allDisabled ? actions[0].title : undefined,
  };
}
